import { useEffect, useState } from 'react';
import { api, AuditEntry } from '../api';
import type { Session } from '../App';
import { Container, PageHeader } from '../App';

interface Props { session: Session; }

export default function Audit({ session }: Props) {
  const [rows, setRows] = useState<AuditEntry[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [pkg, setPkg] = useState('');
  const [type, setType] = useState('');
  const [limit, setLimit] = useState('50');

  const reload = () => {
    const filters: Record<string, string> = { limit };
    if (pkg) filters.package = pkg;
    if (type) filters.event_type = type;
    api.auditLog(session.gameId, filters).then(setRows).catch(e => setError(e.message));
  };
  useEffect(reload, [session.gameId, pkg, type, limit]);

  return (
    <Container>
      <PageHeader
        title="Audit Log"
        subtitle="Append-only event stream across every package in this game."
        actions={
          <button className="btn" onClick={reload}>↻ Refresh</button>
        }
      />

      {error && <div className="error-banner">{error}</div>}

      <div className="card mb-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div>
            <label className="block text-[11.5px] uppercase tracking-wider font-medium text-fg-dim mb-1.5">
              Package
            </label>
            <input
              className="input"
              placeholder="e.g. resource"
              value={pkg}
              onChange={e => setPkg(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-[11.5px] uppercase tracking-wider font-medium text-fg-dim mb-1.5">
              Event type
            </label>
            <input
              className="input"
              placeholder="e.g. resource_changed"
              value={type}
              onChange={e => setType(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-[11.5px] uppercase tracking-wider font-medium text-fg-dim mb-1.5">
              Limit
            </label>
            <input
              className="input"
              type="number"
              value={limit}
              onChange={e => setLimit(e.target.value)}
            />
          </div>
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="empty">
          <div className="text-fg-2 font-medium mb-1">No audit records</div>
          <div className="text-xs text-fg-muted">Mutations from any package land here.</div>
        </div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>When</th>
                <th>Package</th>
                <th>Event</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td className="text-xs text-fg-muted">
                    {new Date(r.at).toLocaleString()}
                  </td>
                  <td>
                    <span className="badge badge-muted">{r.package}</span>
                  </td>
                  <td className="font-mono text-xs">{r.event_type}</td>
                  <td>
                    <code className="text-[11.5px] text-fg-2">
                      {JSON.stringify(r.data)}
                    </code>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Container>
  );
}
